import React from 'react';

const SvgCn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CN_svg__b" fill="#fff">
        <use xlinkHref="#CN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#CN_svg__a" />
      <path fill="#F1361D" mask="url(#CN_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M13.506 5.977l-.84.511.023-.982-.51-.84.982.023.839-.51-.023.982.511.839-.982-.023zM11.04 3.266l-.968-.165.661-.727.165-.968.727.661.968.166-.661.726-.166.968-.726-.661zm.487 8.705l-.82.54-.012-.983-.54-.82.982-.012.821-.54.012.982.54.821-.983.012zm1.69-2.648l-.977.108.436-.88-.108-.977.88.436.977-.108-.436.88.108.977-.88-.436zM6.667 8.227L4.316 9.903l.867-2.754-2.32-1.718 2.887-.026.917-2.738.917 2.738 2.887.026-2.32 1.718.867 2.754z"
        fill="#FFDC42"
        mask="url(#CN_svg__b)"
      />
    </g>
  </svg>
);

export default SvgCn;
